import React from 'react';
import {Box, Chip, Stack, TableCell, Typography, useTheme} from '@mui/material';
import {Procedure} from 'domain/usecases';
import {translations} from 'presentation/translations-new';
import {formatPrice} from 'presentation/utils';

const {code} = translations['pt-br'].privateFlow.franchisesTable;

export const TableMobileRow = (procedure: Procedure) => {
	const theme = useTheme();

	return (
		<TableCell colSpan={3} sx={{padding: '12px 16px'}}>
			<Stack gap={1}>
				<Typography variant="body1" color="text.primary">
					{procedure.nmProcedimento}
				</Typography>
				<Box display="flex" justifyContent="space-between" alignItems="center">
					<Typography variant="body2" fontSize="	0.75rem" color="text.secondary">
						{code}: {procedure.cdProcedimento}
					</Typography>
					<Chip
						label={formatPrice(procedure.valorProcedimento.toFixed(2))}
						size="medium"
						sx={{
							height: 24,
							backgroundColor: theme.colors.light.primary['10Percent'],
							color: theme.palette.primary.main,
							borderRadius: '4px',
							fontWeight: 600,
							padding: '4px 8px',
							lineHeight: '20px',
						}}
					/>
				</Box>
			</Stack>
		</TableCell>
	);
};
